// extracted by mini-css-extract-plugin
export default {"WebEOSSite":"WebEOSSite_WebEOSSite__kcv09","Link":"WebEOSSite_Link__Xpj97"};